import React, { createContext, useContext, useState, useCallback } from 'react';
import placesService from '../../services/places/placesService';

const PlacesContext = createContext(null);

export const PlacesProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const searchPlaces = useCallback(async (query, sessionToken) => {
    if (!query || query.trim().length < 3) {
      return [];
    }
    setIsLoading(true);
    setError(null);
    try {
      const res = await placesService.getAutocomplete(query, sessionToken);
      if (res && res.suggestions) {
        return res.suggestions;
      }
      return [];
    } catch (err) {
      console.error('Error fetching places suggestions:', err);
      setError(err.message || 'Failed to fetch places');
      return [];
    } finally {
      setIsLoading(false);
    }
  }, []);

  const fetchPlaceDetails = useCallback(async (placeId, sessionToken) => {
    if (!placeId) return null;
    setIsLoading(true);
    setError(null);
    try {
      const res = await placesService.getPlaceDetails(placeId, sessionToken);
      if (res && res.place) {
        return res.place;
      }
      return null;
    } catch (err) {
      console.error('Error fetching place details:', err);
      setError(err.message || 'Failed to fetch place details');
      return null;
    } finally {
      setIsLoading(false);
    }
  }, []);

  return (
    <PlacesContext.Provider
      value={{
        isLoading,
        error,
        searchPlaces,
        fetchPlaceDetails
      }}
    >
      {children}
    </PlacesContext.Provider>
  );
};

export const usePlaces = () => {
  const context = useContext(PlacesContext);
  if (!context) {
    throw new Error('usePlaces must be used within a PlacesProvider');
  }
  return context;
};

export default PlacesContext;
